'use strict';

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ItemTitleBar = require('./item-title-bar');

var FlyIn = require('./fly-in');

var DownLoadCenter = require('./download-center/index');

var YPagination = require('./yx-pagination/index');

var fixedBottomContainer = require('./fixed-bottom-container/index');

var YFilePreview = require('./y-file-preview');

function _interopDefaultLegacy(e) {
  return e && _typeof(e) === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var ItemTitleBar__default = /*#__PURE__*/_interopDefaultLegacy(ItemTitleBar);

var FlyIn__default = /*#__PURE__*/_interopDefaultLegacy(FlyIn);

var DownLoadCenter__default = /*#__PURE__*/_interopDefaultLegacy(DownLoadCenter);

var YPagination__default = /*#__PURE__*/_interopDefaultLegacy(YPagination);

var fixedBottomContainer__default = /*#__PURE__*/_interopDefaultLegacy(fixedBottomContainer);

var YFilePreview__default = /*#__PURE__*/_interopDefaultLegacy(YFilePreview);

var components = [ItemTitleBar__default['default'], YPagination__default['default'], fixedBottomContainer__default['default']];
var plugins = [FlyIn__default['default'], DownLoadCenter__default['default'], YFilePreview__default['default']];

var install = function install(Vue) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue.prototype.$YX_OPTIONS = options;
  components.forEach(function (item) {
    _newArrowCheck(this, _this);

    Vue.component(item.name, item);
  }.bind(this));
  plugins.forEach(function (item) {
    _newArrowCheck(this, _this);

    Vue.use(item);
  }.bind(this));
};

var index = {
  install: install
};
Object.defineProperty(exports, 'ItemTitleBar', {
  enumerable: true,
  get: function get() {
    return ItemTitleBar__default['default'];
  }
});
Object.defineProperty(exports, 'FlyIn', {
  enumerable: true,
  get: function get() {
    return FlyIn__default['default'];
  }
});
Object.defineProperty(exports, 'DownLoadCenter', {
  enumerable: true,
  get: function get() {
    return DownLoadCenter__default['default'];
  }
});
exports["default"] = index;
